import {
  Box,
  Button,
  Center,
  Flex,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from '@mantine/core'
import { modals } from '@mantine/modals'

import { useCreateClinc } from '../../hooks/useCreateClincInformation.hook'

const CreateClinicModal = () => {
  const { form, onSubmit } = useCreateClinc()

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <Center>
        <Text fz="h3" fw="bold">
          Create New Clinic
        </Text>
      </Center>
      <Box p="lg">
        <SimpleGrid mb="lg" cols={2} spacing="lg">
          <Select
            key={form.key('program')}
            label="Clinic Type"
            placeholder="Select Clinic Type"
            data={[
              { label: 'Dental', value: 'DENTAL' },
              { label: 'Vision', value: 'VISION' },
            ]}
            withAsterisk
            {...form.getInputProps('program')}
          />

          <TextInput
            key={form.key('name')}
            label="Clinic Name"
            placeholder="Enter Clinic Name"
            withAsterisk
            {...form.getInputProps('name')}
          />
        </SimpleGrid>
      </Box>

      <Box>
        <Flex justify="space-between" align="center">
          <Button variant="outline" onClick={() => modals.closeAll()}>
            Cancel
          </Button>
          <Button type="submit">Create Clinic & Continue</Button>
        </Flex>
      </Box>
    </form>
  )
}

export const openCreateClinicModal = () =>
  modals.open({
    children: <CreateClinicModal />,
    size: 'xl',
    centered: true,
  })
